module.exports = {"id":"224396","name":"Yeimar Gómez Andrade","rating":"71","photo":"./data/images/photos/4/224396.png","club":{"name":"Unión","logo":"./data/images/clubs/Union.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YeimarGomezAndrade0.json
// module id = 4401
// module chunks = 0